export default {"src":"/_next/static/media/heart.6d48a442.svg","height":30,"width":29,"blurWidth":0,"blurHeight":0};